import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { type InputType } from 'config'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { Button } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

interface ConfigurationFormProps {
  defaultInputs: Record<string, InputType>
  configurationKey: string
}

export const ConfigurationForm = ({ defaultInputs, configurationKey }: ConfigurationFormProps) => {
  const [inputs, setInputs] = useState(() => cloneDeep(defaultInputs))
  const [isLoading, setLoading] = useState(false)
  const [isChanged, setChanged] = useState(false)

  useEffect(() => {
    setLoading(true)
    getAdminConfig(configurationKey)
      .then((value) => {
        const newInputs = cloneDeep(defaultInputs)
        Object.keys(newInputs).forEach((key) => {
          if (value[key] !== undefined) {
            newInputs[key].value = value[key]
          }
        })
        setInputs(newInputs)
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: any) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    setInputs(newInputs)
    setChanged(true)
  }

  const onSubmit = async () => {
    const data: Record<string, any> = {}
    Object.keys(inputs).forEach((key) => {
      if (inputs[key].inputType === 'section') return
      data[key] = inputs[key].value
    })
    setLoading(true)
    await setAdminConfig(configurationKey, data)
    setLoading(false)
    setChanged(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />

      <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-2 gap-2 mb-6">
        {Object.keys(inputs).map((key, index) => {
          const input = inputs[key]
          return (
            <div className={`input md:col-span-${input.span || 1} `} key={index}>
              <RenderInput
                key={index}
                input={input}
                Key={key}
                onChange={(_: any, value: any) => onChange(key, value)}
              />
            </div>
          )
        })}
      </div>

      <Button disabled={!isChanged} onClick={onSubmit}>
        Save
      </Button>
      <SaveChanges show={isChanged} label="Save Changes" onSave={onSubmit} />
    </div>
  )
}
